import _ from 'lodash';

export const FEEDBACK_ID = 'cape_qualtric_feedback';
export const ESCAPE_HATCH_ID = 'cape-qualtrics-escapehatch';

export const handleQualtricsClick = function(e, id, intercept_id = undefined, callback = undefined) {
    e.preventDefault();
    const paypal = _.get(window, 'PAYPAL', undefined);
    const QSI = _.get(window, 'QSI', undefined);
    if (typeof paypal !== 'undefined' && paypal.analytics) {
        paypal.analytics.reloadQualtrics(id);
        if (intercept_id !== undefined && callback !== undefined) {
            QSI.API.getIntercept(intercept_id).then(function(interceptAPI) {
                interceptAPI.onClose(function() {
                    callback();
                });
            });
        }
    }
};
